import React, { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const SeoCopySection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$seoCopySection' });

  return (
    <section className="base-section seo-section">
      <div className="seo-copy">
        <h2 className="section-title">{t('seoTitle')}</h2>
        <p className="section-txt">{t('bringComfort')}</p>
      </div>
    </section>
  );
};

export default SeoCopySection;
